import {useInfiniteQuery} from 'react-query';

import {getComments} from '../../../../services/comment';
import {postOwnerType} from '../../../../models/post/postOwnerType';

const UseGetComments = (type: postOwnerType) => {
  const {data, isLoading, fetchNextPage} = useInfiniteQuery(
    ['shopComments'],
    ({pageParam = 1}) => getComments(type, pageParam),
    {
      getNextPageParam: (_, allPages) => {
        return allPages[allPages.length - 1].next
          ? new URL(allPages[allPages.length - 1]?.next || '').searchParams.get(
              'page',
            )
          : undefined;
      },
    },
  );

  return {data, isLoading, fetchNextPage};
};

export default UseGetComments;
